import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class RegistryUploadRunService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.REGISTRY_UPLOAD_RUN = '/api/registry-upload-run';

        this.GET_BY_ID = '/{id}';
        this.UPLOAD = '/upload';
        this.GET_STATUS = '/status/{id}';
        this.GET_LIST_BY_PROJECT_ID = '/list/projectid/{projectId}';
        this.GET_LIST_BY_PROJECT_ID_REGISTRY_TYPE = '/list/projectid/{projectId}/{registryType}';
    }

    async getById(id) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.REGISTRY_UPLOAD_RUN + this.GET_BY_ID;
        url = url
            .replace('{id}', id);
        try{
            const registryUploadRunStatus = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return registryUploadRunStatus;
        } catch(err) {
            console.log(err);
        }
    }

    async uploadBulkRegistries(excelFile) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.REGISTRY_UPLOAD_RUN + this.UPLOAD;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(excelFile)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async getRegistryUploadRunStatus(id) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.REGISTRY_UPLOAD_RUN + this.GET_STATUS;
        url = url
            .replace('{id}', id);
        try{
            const registryUploadRunStatus = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return registryUploadRunStatus;
        } catch(err) {
            console.log(err);
        }
    }

    async getRegistryUploadRunListByProjectId(projectId) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.REGISTRY_UPLOAD_RUN + this.GET_LIST_BY_PROJECT_ID;
        url = url
            .replace('{projectId}', projectId);
        try{
            const registryUploadRunList = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return registryUploadRunList;
        } catch(err) {
            console.log(err);
        }
    }

    async getRegistryUploadRunListByProjectIdAndRegistryType(projectId, registryType) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.REGISTRY_UPLOAD_RUN + this.GET_LIST_BY_PROJECT_ID_REGISTRY_TYPE;
        url = url
            .replace('{projectId}', projectId)
            .replace('{registryType}', registryType);
        try{
            const registryUploadRunList = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return registryUploadRunList;
        } catch(err) {
            console.log(err);
        }
    }
}

export default RegistryUploadRunService;